export default __webpack_public_path__ + "98e7e703776a57fc6db02b8d598258e5.png";